import { jsxs, jsx } from 'react/jsx-runtime';
import { useDocumentClick, Select, Input, Magnifier } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import { useState, useRef } from 'react';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const searchOptionList = [
    {
        text: 'All Sections',
        value: 'all',
    },
    {
        text: 'New Cars',
        value: 'newcar',
    },
    {
        text: 'Used Cars',
        value: 'usedcar',
    },
    {
        text: 'Rental Cars',
        value: 'rentalcar',
    },
    {
        text: 'e-Shop',
        value: 'eshop',
    },
    {
        text: 'Motor Directory',
        value: 'motordirectory',
    },
    {
        text: 'Product Guide',
        value: 'accessories',
    },
    {
        text: 'Articles',
        value: 'article',
    },
    {
        text: 'Forum',
        value: 'forum',
    },
];
const categoryList = [
    {
        value: 'all',
        name: 'all',
        href: new URL('https://www.sgcarmart.com/search'),
    },
    {
        value: 'newcar',
        name: 'new-cars',
        href: new URL(' https://www.sgcarmart.com/new_cars/newcars_listing.php'),
    },
    {
        value: 'usedcar',
        name: 'used-cars',
        href: new URL('https://www.sgcarmart.com/used_cars/listing.php'),
    },
    {
        value: 'rentalcar',
        name: 'rental-cars',
        href: new URL('https://www.sgcarmart.com/car_rental/index.php'),
    },
    {
        value: 'motordirectory',
        name: 'motor-directory',
        href: new URL('https://www.sgcarmart.com/directory/listing.php'),
    },
    {
        value: 'accessories',
        name: 'product-guide',
        href: new URL('https://www.sgcarmart.com/products/listing.php'),
    },
    {
        value: 'article',
        name: 'articles',
        href: new URL('https://www.sgcarmart.com/articles'),
    },
    {
        value: 'forum',
        name: 'forum',
        href: new URL('https://www.mycarforum.com/search'),
    },
    {
        value: 'eshop',
        name: 'eshop',
        href: new URL('https://www.sgcarmart.com/shop/Tyres?shopBy=size&width=&profile=&rim='),
    },
];

const SEARCH_INPUT_MAGNIFIER_ICON_SIZE = 20;
const NEXT_PUBLIC_MCF_BASE_URL = 'https://www.mycarforum.com';

var css_248z = ".SGCM_UIKIT_NEXT_SearchInput_containerSectionSelect_1ctfa_1 {\n  height: 100%;\n}\n\n.SGCM_UIKIT_NEXT_SearchInput_headerSelectSection_1ctfa_5 {\n  min-width: 170px;\n  height: 100%;\n  border-right: unset;\n  border-bottom-right-radius: unset;\n  border-top-right-radius: unset;\n}\n\n.SGCM_UIKIT_NEXT_SearchInput_containerSelectMenu_1ctfa_13 {\n  z-index: 1050;\n}\n\n.SGCM_UIKIT_NEXT_SearchInput_inputSearch_1ctfa_17 {\n  border-color: transparent;\n  background-color: #f4f4f4;\n  grid-column: 1/3;\n  grid-row: 1/2;\n}\n.SGCM_UIKIT_NEXT_SearchInput_inputSearch_1ctfa_17:focus {\n  background-color: white;\n}\n\n.SGCM_UIKIT_NEXT_SearchInput_buttonSearch_1ctfa_27 {\n  padding: 0 17px;\n  border: 0;\n  border-radius: 6px;\n  background-color: #f4f4f4;\n  cursor: pointer;\n  grid-column: 2/3;\n  grid-row: 1/2;\n  line-height: 0;\n}\n\n.SGCM_UIKIT_NEXT_SearchInput_containerMagnifierIcon_1ctfa_38 {\n  color: #5f5f5f;\n}\n\n.SGCM_UIKIT_NEXT_SearchInput_containerRoot_1ctfa_42 {\n  display: grid;\n  width: 276px;\n  grid-template-columns: 1fr auto;\n  transition: width 500ms ease;\n}\n.SGCM_UIKIT_NEXT_SearchInput_containerRoot_1ctfa_42.SGCM_UIKIT_NEXT_SearchInput_isStretched_1ctfa_48 {\n  width: min(100%, 650px);\n  grid-template-columns: auto 1fr auto;\n}\n.SGCM_UIKIT_NEXT_SearchInput_containerRoot_1ctfa_42.SGCM_UIKIT_NEXT_SearchInput_isStretched_1ctfa_48 > .SGCM_UIKIT_NEXT_SearchInput_inputSearch_1ctfa_17 {\n  border-color: #c4c9cd;\n  border-bottom-left-radius: unset;\n  border-top-left-radius: unset;\n  grid-column: 2/4;\n}\n.SGCM_UIKIT_NEXT_SearchInput_containerRoot_1ctfa_42.SGCM_UIKIT_NEXT_SearchInput_isStretched_1ctfa_48 > .SGCM_UIKIT_NEXT_SearchInput_buttonSearch_1ctfa_27 {\n  background-color: transparent;\n  grid-column: 3/4;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles = {"containerSectionSelect":"SGCM_UIKIT_NEXT_SearchInput_containerSectionSelect_1ctfa_1","headerSelectSection":"SGCM_UIKIT_NEXT_SearchInput_headerSelectSection_1ctfa_5","containerSelectMenu":"SGCM_UIKIT_NEXT_SearchInput_containerSelectMenu_1ctfa_13","inputSearch":"SGCM_UIKIT_NEXT_SearchInput_inputSearch_1ctfa_17","buttonSearch":"SGCM_UIKIT_NEXT_SearchInput_buttonSearch_1ctfa_27","containerMagnifierIcon":"SGCM_UIKIT_NEXT_SearchInput_containerMagnifierIcon_1ctfa_38","containerRoot":"SGCM_UIKIT_NEXT_SearchInput_containerRoot_1ctfa_42","isStretched":"SGCM_UIKIT_NEXT_SearchInput_isStretched_1ctfa_48"};
styleInject(css_248z);

const createSearchUrl = ({ section, keyword }) => {
    if (!section) {
        return null;
    }
    const encodedKeyword = keyword ? keyword.replaceAll(' ', '+') : null;
    const category = categoryList.find(cat => cat.value === section);
    const target = section === 'forum' ? '_blank' : '_self';
    if (!keyword && category) {
        return {
            searchUrl: new URL(category.href),
            target,
        };
    }
    if (section === 'eshop') {
        const searchUrl = new URL(`/shop/Tyres?profile=&rim=&search=${encodedKeyword}&shopBy=size&width=`, window.location.origin);
        return { searchUrl, target };
    }
    if (section === 'forum') {
        const searchUrl = new URL(`${NEXT_PUBLIC_MCF_BASE_URL}/index.php?app=core&module=search&controller=search&q=${encodedKeyword}&type=forums_topic&search_and_or=or&sortby=relevancy`, window.location.origin);
        return { searchUrl, target };
    }
    const searchUrl = new URL('/search', window.location.origin);
    const { searchParams } = searchUrl;
    const catName = category ? category.name : 'all';
    searchParams.append('CAT', catName);
    searchParams.append('q', keyword);
    return { searchUrl, target };
};

const SearchInput = () => {
    const [section, setSection] = useState(searchOptionList[0].value);
    const [keyword, setKeyword] = useState('');
    const [isStretched, setIsStretched] = useState(false);
    const containerRootElRef = useRef(null);
    const searchInputElRef = useRef(null);
    const onDocClickRef = useRef(null);
    onDocClickRef.current = ({ target }) => {
        if (!(target instanceof Element)
            || containerRootElRef.current?.contains(target)) {
            return;
        }
        setIsStretched(false);
    };
    const onSearch = () => {
        const searchUrlData = createSearchUrl({
            section,
            keyword,
        });
        if (!searchUrlData) {
            return;
        }
        const { searchUrl, target } = searchUrlData;
        window.open(searchUrl, target, 'noopener noreferrer');
    };
    useDocumentClick({
        onClickRef: onDocClickRef,
    });
    return (jsxs("div", { ref: containerRootElRef, className: cx(styles.containerRoot, {
            [styles.isStretched]: isStretched,
        }), children: [isStretched && (jsx(Select, { className: styles.containerSectionSelect, headerClassName: styles.headerSelectSection, menuContainerClassName: styles.containerSelectMenu, optionList: searchOptionList, value: section, onChange: (value) => {
                    setSection(`${value}`);
                } })), jsx(Input, { ref: searchInputElRef, className: styles.inputSearch, placeholder: isStretched ? 'What are you looking for?' : undefined, value: keyword, onChange: ({ target: { value } }) => {
                    setKeyword(value);
                }, onFocus: () => {
                    setIsStretched(true);
                }, onKeyDown: ({ key }) => {
                    if (key !== 'Enter') {
                        return;
                    }
                    onSearch();
                } }), jsx("button", { "aria-label": "Search with category and keyword", className: styles.buttonSearch, onClick: () => {
                    setIsStretched(true);
                    searchInputElRef.current?.focus();
                    onSearch();
                }, children: jsx("div", { className: styles.containerMagnifierIcon, children: jsx(Magnifier, { size: SEARCH_INPUT_MAGNIFIER_ICON_SIZE }) }) })] }));
};

export { SearchInput as S };
//# sourceMappingURL=component-CNkB69_x.js.map
